import React, { useState, useEffect } from "react";
import AdminTopbar from "../../Layouts/Admin_layout/Admin_topbar";
import {
  Table,
  TableContainer,
  Typography,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  Button,
  Pagination,
  Grid,
  TextField,
  DialogContent,
  Autocomplete,
  Chip,
  FormControl,
  MenuItem,
  Modal,
  Box,
  Dialog,
  DialogTitle,
  IconButton,
} from "@mui/material";
import "../../Styles/Pages/admin_fieldofficers.css";
import SearchIcon from "@mui/icons-material/Search";
import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import CloseIcon from "@mui/icons-material/Close";
import { instance } from "../../utils/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { jwtDecode } from "jwt-decode";
import { EditNote } from "@mui/icons-material";
import { NavLink } from "react-router-dom";
import { FiEye } from "react-icons/fi";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
  border: "1px solid #79c245",
  marginRight: "10px",
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#79c245",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  fontFamily: "Poppins,sans-serif",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

function FieldOfficers() {
  const [search, setSearch] = useState("");
  const [fieldOfficersData, setFieldOfficersData] = useState([]);
  const [filteredOfficers, setFilteredOfficers] = useState([]);
  const [open, setOpen] = useState(false);
  const [locations, setLocations] = useState([]);
  const [errors, setErrors] = useState({});
  const token = localStorage.getItem("token");
  const decodedToken = jwtDecode(token);
  const vendorId = decodedToken.vendor_id;
  const [isEditing, setIsEditing] = useState(false);

  const handleOpen = () => {
    fetchLocationsByVendor(vendorId);
    setOpen(true);
    setIsEditing(false);
  };

  const handleClose = () => {
    setOpen(false);
    setOfficerData({
      name: "",
      mobile_no: "",
      vendor_id: vendorId,
      location_hash: [],
      email: "",
      password: "",
      blood_group: "",
      experience: "",
    });
    setErrors({});
  };

  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [officerStatus, setOfficerStatus] = useState(null);

  const handleStatusOpen = (officer) => {
    setOpenStatusModal(true);
    setOfficerStatus(officer);
  };

  const handleStatusClose = () => {
    setOpenStatusModal(false);
  };

  const [officerData, setOfficerData] = useState({
    employee_id: "",
    name: "",
    mobile_no: "",
    gender: "",
    blood_group: "",
    address: "",
    vendor_id: vendorId,
    location_hash: [],
    email: "",
    password: "",
    experience: "",
  });

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 2,
    borderRadius: "2px",
  };

  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    setSearch(query);

    if (query === "") {
      setFilteredOfficers(fieldOfficersData);
    } else {
      const filtered = fieldOfficersData.filter((officer) =>
        Object.values(officer).some((value) =>
          value.toString().toLowerCase().includes(query)
        )
      );
      setFilteredOfficers(filtered);
    }
    setCurrentPage(1);
  };

  const fetchOfficerStatus = async (selectedStatus) => {
    try {
      const newStatus = selectedStatus?.status === false ? true : false;
      const response = await instance.post("/field_officer/setStatus", {
        status: newStatus,
        fieldofficer_hash: selectedStatus.hash,
      });
      setFieldOfficersData(response.data.data.status);
      fetchFieldOfficers();
      if (response.status === 200) {
        toast.success("status updated successfully", { toastId: "update-success", autoClose: 5000 });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setOfficerData({ ...officerData, [name]: value });
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value ? "" : prevErrors[name],
      mobile_no:
        value.length < 10 && name === "mobile_no"
          ? "mobile number should be 10 digits"
          : "",
    }));
  };

  const handleLocationChange = (event, value) => {
    setOfficerData({ ...officerData, location_hash: value });
    setErrors((prevErrors) => ({
      ...prevErrors,
      location_hash: value.length ? "" : prevErrors.location_hash,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!officerData.name) {
      newErrors.name = "Name is required";
    } else {
      setErrors("");
    }
    if (!officerData.mobile_no) {
      newErrors.mobile_no = "Mobile number is required";
    } else if (!/^\d{10}$/.test(officerData.mobile_no)) {
      newErrors.mobile_no = "Please enter a valid 10-digit mobile number";
    } else {
      setErrors("");
    }
    if (!officerData.gender) {
      newErrors.gender = "Select Gender";
    } else {
      setErrors("");
    }
    if (!officerData.blood_group) {
      newErrors.blood_group = "Select Blood Group";
    } else {
      setErrors("");
    }
    if (!officerData.address) {
      newErrors.address = "Address is required";
    } else {
      setErrors("");
    }
    if (!officerData.experience) {
      newErrors.experience = "Experience is required";
    }
    else {
      setErrors("");
    }
    // if (!officerData.email) {
    //   newErrors.email = "Email is required";
    // } else {
    //   setErrors("");
    // }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(officerData.email.toString().trim())) {
      newErrors.email = "Enter a valid email address";
    } else {
      setErrors("")
    }
    if (!officerData.password && !isEditing) {
      newErrors.password = "Password is required";
    } else {
      setErrors("");
    }
    if (officerData.location_hash.length === 0) {
      newErrors.location_hash = "Select atleast one Location";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const fetchFieldOfficers = async () => {
    try {
      const response = await instance.get("/field_officer/getFieldOfficers");
      const sortedFieldofficers = response.data.data.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      setFieldOfficersData(sortedFieldofficers);
      setFilteredOfficers(response.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchLocationsByVendor = async (vendorId) => {
    try {
      const response = await instance.get(`/locations?vendorId=${vendorId}`);
      setLocations(response.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchFieldOfficers();
    fetchLocationsByVendor(vendorId);
  }, [vendorId]);

  const [currentPage, setCurrentPage] = useState(1);
  const officersPerPage = 10;
  const indexOfLastOfficer = currentPage * officersPerPage;
  const indexOfFirstOfficer = indexOfLastOfficer - officersPerPage;
  const currentOfficers = Array.isArray(filteredOfficers)
    ? filteredOfficers.slice(indexOfFirstOfficer, indexOfLastOfficer)
    : [];

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const addfieldofficers = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    try {
      const response = await instance.post("/field_officer/signup", {
        ...officerData,
        location_hashes: officerData.location_hash.map(
          (location) => location.hash
        ),
      });

      if (response.status === 200) {
        setFieldOfficersData((prevData) => [...prevData, response.data.data]);
        toast.success(response.data.msg);
        fetchFieldOfficers();
        handleClose();
      }
    } catch (err) {
      const errorMsg = err.response?.data?.error || err.response?.data?.message || "";
      if (errorMsg.includes("email_1")) {
        toast.error(`Email ${officerData.email} already exists`, { toastId: "login-error", autoClose: 5000 });
      } else if (errorMsg.includes("mobile_no_1")) {
        toast.error(`Mobile Number ${officerData.mobile_no} already exists`, { toastId: "login-error", autoClose: 5000 });
      } else {
        toast.error(errorMsg || "Error adding field officer", { toastId: "login-error", autoClose: 5000 });
      }
      console.error("Error adding field officer:", err);
    }
  };

  const updatefieldsofficers = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    try {
      const response = await instance.post(
        "/field_officer/updateProfile",
        {
          name: officerData.name,
          mobile_no: officerData.mobile_no,
          gender: officerData.gender,
          blood_group: officerData.blood_group,
          address: officerData.address,
          location_hashes: officerData.location_hash.map(
            (location) => location.hash
          ),
          email: officerData.email,
          fieldofficer_hash: officerData.hash,
          experience: officerData.experience,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      fetchFieldOfficers();
      handleClose();
      if (response.status === 200) {
        toast.success(response.data.msg, { toastId: "update-error", autoClose: 5000 });
      }
    } catch (error) {
      const errorMsg = error?.response?.data?.error || "";

      if (errorMsg.includes("email_1")) {
        toast.error(`Email ${officerData.email} already exists`, { toastId: "update-error", autoClose: 5000 });
      } else if (errorMsg.includes("mobile_no_1")) {
        toast.error(`Mobile Number ${officerData.mobile_no} already exists`, { toastId: "update-error", autoClose: 5000 });
      } else {
        toast.error(errorMsg || "An unexpected error occurred", { toastId: "update-error", autoClose: 5000 });
      }
      console.error("Error updating field officer:", error);
    }
  };

  const handleEditClick = (fieldofficer) => {
    setIsEditing(true);
    officerData.name = fieldofficer.name;
    officerData.mobile_no = fieldofficer.mobile_no;
    officerData.gender = fieldofficer.gender;
    officerData.blood_group = fieldofficer.blood_group;
    officerData.address = fieldofficer.address;
    officerData.experience = fieldofficer.experience;
    officerData.location_hash = locations.filter((location) =>
      fieldofficer.location_hash.includes(location.hash)
    );
    officerData.email = fieldofficer.email;
    officerData.hash = fieldofficer.hash;
    setErrors("");
    setOpen(true);
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (isEditing) {
      updatefieldsofficers();
    } else {
      addfieldofficers();
    }
  };

  const genderOptions = [
    { value: "Male", name: "male" },
    { value: "Female", name: "female" },
  ];

  const bloodgroupOptions = [
    { value: "A+", name: "A+" },
    { value: "A-", name: "A-" },
    { value: "B+", name: "B+" },
    { value: "B-", name: "B-" },
    { value: "AB+", name: "AB+" },
    { value: "AB-", name: "AB-" },
    { value: "O+", name: "O+" },
    { value: "O-", name: "O-" },
  ];

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 48 * 3 + 8,
      },
    },
  };

  const handleSpaceChange = (e) => {
    const { name, value: rawValue } = e.target;
    let value = rawValue;

    // Prevent leading space
    if (value.startsWith(" ")) return;

    // Replace multiple spaces with a single space
    value = value.replace(/\s{2,}/g, " ");

    // Restrict experience field to numbers only
    if (name === "experience") {
      // Remove any non-digit characters
      value = value.replace(/\D/g, "");
    }

    // Update state
    setOfficerData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Validation
    setErrors((prev) => ({
      ...prev,
      [name]: value.trim() === "" ? `${capitalize(name)} is required` : "",
    }));
  };

  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);



  return (
    <div style={{ margin: "20px 20px 0px 0px" }}>
      <AdminTopbar />
      <div className="officer_section">
        <BootstrapDialog
          className="sales_entry"
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            <Typography sx={{ fontFamily: 'Poppins,sans-serif' }}>
              {isEditing ? "Edit Field Officer" : "Add Field Officer"}
            </Typography>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent>
            <form onSubmit={submitHandler}>
              <div className="adduser_bg">
                <div className="user_form">
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        id="outlined-basic"
                        label="Name"
                        variant="outlined"
                        name="name"
                        value={officerData.name}
                        onChange={handleSpaceChange}
                        error={!!errors.name}
                        helperText={errors.name}
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        id="outlined-basic"
                        label="Mobile No"
                        variant="outlined"
                        name="mobile_no"
                        value={officerData.mobile_no}
                        onChange={(e) => {
                          if (
                            /^\d*$/.test(e.target.value) &&
                            e.target.value.length <= 10
                          ) {
                            handleChange(e);
                          }
                        }}
                        error={!!errors.mobile_no}
                        helperText={errors.mobile_no}
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl fullWidth error={!!errors.gender}>
                        <TextField
                          fullWidth
                          select
                          required
                          label="Gender"
                          value={officerData.gender}
                          name="gender"
                          onChange={handleChange}
                          error={!!errors.gender}
                          helperText={errors.gender}
                          variant="outlined"
                        >
                          {genderOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl fullWidth error={!!errors.blood_group}>
                        <TextField
                          fullWidth
                          select
                          required
                          label="Blood Group"
                          value={officerData.blood_group}
                          name="blood_group"
                          onChange={handleChange}
                          error={!!errors.blood_group}
                          helperText={errors.blood_group}
                          variant="outlined"
                          SelectProps={{
                            MenuProps: MenuProps,
                          }}
                        >
                          {bloodgroupOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        id="outlined-basic"
                        label="Address"
                        variant="outlined"
                        name="address"
                        value={officerData.address}
                        onChange={handleSpaceChange}
                        error={!!errors.address}
                        helperText={errors.address}
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Autocomplete
                        multiple
                        limitTags={10}
                        id="location-autocomplete"
                        options={locations}
                        getOptionLabel={(option) => option.name}
                        value={officerData.location_hash}
                        onChange={handleLocationChange}
                        renderTags={(tagValue, getTagProps) =>
                          tagValue.map((option, index) => (
                            <Chip
                              label={option.name}
                              {...getTagProps({ index })}
                            />
                          ))
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Location"
                            placeholder="Select locations"
                            error={!!errors.location_hash}
                            helperText={errors.location_hash}
                            required
                          />
                        )}
                        clearIcon={null}
                        disableClearable
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        id="outlined-basic"
                        label="Email"
                        variant="outlined"
                        name="email"
                        value={officerData.email}
                        onChange={handleSpaceChange}
                        error={!!errors.email}
                        helperText={errors.email}
                        required
                      />
                    </Grid>
                    {isEditing ? (
                      ""
                    ) : (
                      <Grid item xs={12}>
                        <TextField
                          id="outlined-basic"
                          label="Password"
                          variant="outlined"
                          name="password"
                          type="password"
                          value={officerData.password}
                          onChange={handleChange}
                          error={!!errors.password}
                          helperText={errors.password}
                          required
                        />
                      </Grid>
                    )}
                    <Grid item xs={12}>
                      <TextField
                        id="outlined-basic"
                        label="Experience"
                        variant="outlined"
                        name="experience"
                        value={officerData.experience}
                        onChange={handleSpaceChange}
                        error={!!errors.experience}
                        helperText={errors.experience}
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <div className="cancel_save_user">
                        <Button
                          className="cancel"
                          variant="outlined"
                          onClick={handleClose}
                        >
                          Cancel
                        </Button>
                        <Button
                          onClick={
                            isEditing ? updatefieldsofficers : addfieldofficers
                          }
                          className="save_user"
                        >
                          {isEditing ? "Update" : "Add"}
                        </Button>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </form>
          </DialogContent>
        </BootstrapDialog>
        <section>
          <div className="container-fluid">
            <div className="table_box">
              <TableContainer component={Paper}>
                <div className="table_inbox">
                  <div className="add_user_list">
                    <div className="add_user_content">
                      <div
                        style={{
                          fontFamily: "Poppins,sans-serif",
                          fontSize: "20px",
                          fontWeight: "bold",
                        }}
                      >
                        Field Officers
                      </div>
                    </div>
                    <div className="add_user">
                      <div>
                        <Search>
                          <SearchIconWrapper>
                            <SearchIcon />
                          </SearchIconWrapper>
                          <StyledInputBase
                            placeholder="Search…"
                            inputProps={{ "aria-label": "search" }}
                            type="search"
                            value={search}
                            onChange={handleSearch}
                          />
                        </Search>
                      </div>
                      <Button variant="outlined" onClick={handleOpen}>
                        Add Field Officer
                      </Button>
                    </div>
                  </div>
                  <div className="adduser_table">
                    <Table
                      className="user_table product_table"
                      aria-label="simple table"
                    >
                      <TableHead>
                        <TableRow className="table_head">
                          <TableCell align="center" className="first-child">Sl.No</TableCell>
                          <TableCell align="center" className="first-child">
                            Employee ID
                          </TableCell>
                          <TableCell align="center" className="second-child">
                            Field Officer Name
                          </TableCell>
                          <TableCell align="center" className="third-child">Email</TableCell>
                          <TableCell align="center">Mobile</TableCell>
                          <TableCell align="center">Company</TableCell>
                          <TableCell align="center">Experience</TableCell>
                          <TableCell align="center">Status</TableCell>
                          <TableCell align="center">Manage</TableCell>
                          {currentOfficers[0]?.vendor?.tracking === true ? (<TableCell align="center">Officer Tracking</TableCell>) : null}
                          <TableCell>Check In</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="table_body">
                        {currentOfficers.length > 0 ? (
                          currentOfficers.map((officer, index) => (
                            <TableRow key={officer._id}>
                              <TableCell align="center">
                                {index + 1 + (currentPage - 1) * officersPerPage}
                              </TableCell>
                              <TableCell align="center">
                                {officer.employee_id}
                              </TableCell>
                              <TableCell align="center">{officer.name}</TableCell>
                              <TableCell align="center">{officer.email}</TableCell>
                              <TableCell align="center">
                                {officer.mobile_no}
                              </TableCell>
                              <TableCell align="center">
                                {officer.vendor?.companyname}
                              </TableCell>
                              <TableCell align="center">
                                {officer.experience}
                              </TableCell>
                              <TableCell>
                                <button
                                  className={`officer-status ${officer.status === false
                                    ? "inactive"
                                    : "active"
                                    }`}
                                  onClick={() => handleStatusOpen(officer)}
                                >
                                  {officer.status === false
                                    ? "Inactive"
                                    : "Active"}
                                </button>
                              </TableCell>
                              <TableCell align="center">
                                <div className="farmer-details">
                                  <EditNote
                                    onClick={() => handleEditClick(officer)}
                                    className="view-icon"
                                  />
                                </div>
                              </TableCell>
                              {officer.vendor.tracking === true ? (
                                <TableCell align="center">
                                  <NavLink
                                    to={`/admin/FieldOfficerDetails/${officer.hash}`}
                                    className="farmer-details"
                                  >
                                    <FiEye />
                                  </NavLink>

                                </TableCell>
                              ) : null}
                              <TableCell align="center">
                                <NavLink
                                  to={`/admin/fieldofficerscheckins?hash=${officer.hash}&name=${officer.name}&email=${officer.email}`}
                                  className="farmer-details"
                                >
                                  <FiEye />
                                </NavLink>
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableCell colSpan={12} align="center">
                            <Typography>No matched items</Typography>
                          </TableCell>
                        )}
                      </TableBody>
                    </Table>
                  </div>
                  <div className="pagination_table">
                    <Pagination
                      count={Math.ceil(
                        filteredOfficers.length / officersPerPage
                      )}
                      page={currentPage}
                      onChange={handlePageChange}
                      shape="rounded"
                      variant="outlined"
                    />
                  </div>
                </div>
              </TableContainer>
            </div>
            <Modal
              open={openStatusModal}
              onClose={handleStatusClose}
              aria-labelledby="delete-modal-title"
              aria-describedby="delete-modal-description"
            >
              <Box sx={style}>
                <div id="delete-modal-title">
                  {`Do you want to mark ${officerStatus?.name} as ${officerStatus?.status ? "inactive" : "active"
                    } ?`}
                </div>
                <div id="delete-modal-description">
                  <Button
                    variant="contained"
                    className="yes"
                    onClick={() => {
                      fetchOfficerStatus(officerStatus);
                      setOpenStatusModal(false);
                    }}
                  >
                    Yes
                  </Button>
                  <Button
                    variant="contained"
                    className="no"
                    onClick={handleStatusClose}
                  >
                    No
                  </Button>
                </div>
              </Box>
            </Modal>
          </div>
        </section>
      </div>
    </div>
  );
}

export default FieldOfficers;
